import { sortSabitLookup } from './sabitSort';
import * as glb from '../globals.js';
import { filterKullanicilarByStatu, kulStatuMatches, kulStatuMatchesAny } from './kulStatu';

/** SABIT: Ekimci / Kanalcı / Alımcı işlem türleri (CE_TUR lookup) — satış tipine bağlı değil */
export const EKIM_KANAL_CE_TUR_ST_TUR = 110;

/** CARI_EKIMKANALALIM.CE_TUR (ST_KODINT) → KULLANICI.KUL_STATU (SABIT ST_TUR=130 ST_KODINT) */
export const CE_TUR_TO_KUL_STATU = Object.freeze({ 1: 8, 2: 9, 3: 10 });

export const KUL_STATU_EKIMCI = 8;
export const KUL_STATU_KANALCI = 9;
export const KUL_STATU_ALIMCI_EKIMCI = 10;

export const EKIM_KANAL_KUL_STATU_VALUES = Object.freeze([8, 9, 10]);

/** CARI_KART alanları → beklenen KUL_STATU */
export const CARI_KART_EKIM_KANAL_REF_FIELDS = Object.freeze({
  CAR_EKIM_YAPAN_REF: KUL_STATU_EKIMCI,
  CAR_KANAL_YAP_REF: KUL_STATU_KANALCI,
  CAR_EKIM_YAPAN1_REF: KUL_STATU_ALIMCI_EKIMCI,
});

export { filterKullanicilarByStatu, kulStatuMatches };

export function getEkimciKullanicilar(kullanicilar) {
  return filterKullanicilarByStatu(kullanicilar, KUL_STATU_EKIMCI);
}

export function getKanalciKullanicilar(kullanicilar) {
  return filterKullanicilarByStatu(kullanicilar, KUL_STATU_KANALCI);
}

export function getAlimciEkimciKullanicilar(kullanicilar) {
  return filterKullanicilarByStatu(kullanicilar, KUL_STATU_ALIMCI_EKIMCI);
}

export function getKulStatuForCeTur(ceTur, sabitLkp = null) {
  const ceTurNum = ceTur != null && ceTur !== '' ? Number(ceTur) : null;
  if (ceTurNum == null || !Number.isFinite(ceTurNum)) return null;
  if (CE_TUR_TO_KUL_STATU[ceTurNum] != null) return CE_TUR_TO_KUL_STATU[ceTurNum];

  const list = Array.isArray(sabitLkp) ? sabitLkp : (glb.default?.sabitLkp || []);
  const row = list.find(
    (x) => Number(x.ST_TUR) === EKIM_KANAL_CE_TUR_ST_TUR
      && Number(x.ST_KODINT) === ceTurNum
      && !x.ST_SIL
  );
  const uy = Number(row?.ST_UYAR_YER);
  if (EKIM_KANAL_KUL_STATU_VALUES.includes(uy)) return uy;
  return null;
}

export function isCeTurSelected(ceTur) {
  const n = ceTur != null && ceTur !== '' ? Number(ceTur) : null;
  return n != null && Number.isFinite(n);
}

/** Grid lookup: kayıtlı satırlarda CE_TUR'a göre ad göstermek için tüm roller. */
export function filterEkimKanalKullanicilarForGrid(kullanicilar) {
  const list = Array.isArray(kullanicilar) ? kullanicilar : [];
  return list.filter((k) => kulStatuMatchesAny(k.KUL_STATU, EKIM_KANAL_KUL_STATU_VALUES));
}

/** Form: CE_TUR seçilmeden liste boş; seçilince ilgili statü (8/9/10). */
export function filterEkimKanalKullanicilar(kullanicilar, ceTur = null, sabitLkp = null) {
  const list = Array.isArray(kullanicilar) ? kullanicilar : [];
  if (!isCeTurSelected(ceTur)) return [];
  const statu = getKulStatuForCeTur(ceTur, sabitLkp);
  if (statu == null) return [];
  return filterKullanicilarByStatu(list, statu);
}

/** CE_TUR select/grid listesi: SABIT ST_TUR=110 */
export function getEkimKanalCeTurItems(sabitLkp = null) {
  const list = Array.isArray(sabitLkp) ? sabitLkp : (glb.default?.sabitLkp || []);
  return sortSabitLookup(list.filter(
    (x) => Number(x.ST_TUR) === EKIM_KANAL_CE_TUR_ST_TUR && !x.ST_SIL
  ));
}
